/**
 * Client-only: sessionExpiredHandler opens a browser modal (needs DOM).
 * Must NOT run during SSR — it would overwrite Nitro's optimized
 * globalThis.$fetch (which uses localFetch for in-process routing),
 * causing internal requests to go over the network.
 */
export default defineNuxtPlugin(() => {
    const { isSessionExpired, sessionExpiredHandler } = useSessionExpiration();

    // https://stackoverflow.com/questions/75434573/redefine-fetch-in-nuxt3-with-global-onrequest-handler
    globalThis.$fetch = $fetch.create({
        onResponseError({ response }) {
            if (isSessionExpired(response._data?.error?.code)) {
                sessionExpiredHandler();
            }
        },
    });
});
